import InputField from './InputField';

export default InputField;



// WEBPACK FOOTER //
// ./src/components/InputField/index.js